import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function SearchNoResults({ className, query }) {
  if (!query) {
    return null;
  }

  return (
    <span className={classnames('tertiary db truncate font-16', className)}>
      No results matching &ldquo;{query}&rdquo;
    </span>
  );
}

SearchNoResults.propTypes = {
  className: PropTypes.string,
  query: PropTypes.string.isRequired
};

SearchNoResults.defaultProps = {
  className: 'pv4 ph4'
};
